module.exports = "/build/web/images/newsletter-banner.83695f328a2285f48b449b84c9b452b3.png";


//////////////////
// WEBPACK FOOTER
// ./images/newsletter-banner.png
// module id = 127
// module chunks = 24